// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"j6-z"};